import { ImportCandidateDto } from '../import-candidate-dto';
import { PackagingComponentDto } from 'src/app/data-transfer/entities/component-entities/packaging-component-dto';

export class ImportComponentCandidateDto extends ImportCandidateDto {
    packagingComponent!: PackagingComponentDto;
}
